// src/hooks/usePageContent.js
import { useState } from 'react';
import { getCurrentUser } from '../services/authService';

const useGetUser = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchUserGet = async (userId) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getCurrentUser(userId);

            if (response?.status !== 'Error') {
                setStatus('done');
                setData(response.data ?? response); // depending on API shape
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchUserGet,
        data,
        status,
        error,
        resetStatus
    };
};

export default useGetUser;
